import { AUDIT_IGNORE_FIELDS } from '@/services/audit/constants';

function valuesEqual(a: unknown, b: unknown): boolean {
  if (a === b) return true;
  if (a === undefined || b === undefined) return a === b;
  if (typeof a !== typeof b) return false;
  if (Array.isArray(a) && Array.isArray(b)) {
    if (a.length !== b.length) return false;
    return a.every((item, index) => valuesEqual(item, b[index]));
  }
  if (typeof a === 'object' && a !== null && b !== null) {
    const aObj = a as Record<string, unknown>;
    const bObj = b as Record<string, unknown>;
    const keys = new Set([...Object.keys(aObj), ...Object.keys(bObj)]);
    for (const key of keys) {
      if (!valuesEqual(aObj[key], bObj[key])) return false;
    }
    return true;
  }
  return false;
}

export function getChangedFields(
  before: Record<string, unknown>,
  after: Record<string, unknown>,
  extraIgnore: readonly string[] = [],
): string[] {
  const ignore = new Set<string>([...AUDIT_IGNORE_FIELDS, ...extraIgnore]);
  const keys = new Set([...Object.keys(before), ...Object.keys(after)]);
  const changed: string[] = [];

  for (const key of keys) {
    if (ignore.has(key)) continue;
    if (!valuesEqual(before[key], after[key])) {
      changed.push(key);
    }
  }

  return changed.sort();
}
